import { render, staticRenderFns } from "./PostVersions.vue?vue&type=template&id=d963fcd0&scoped=true&"
import script from "./PostVersions.vue?vue&type=script&lang=js&"
export * from "./PostVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d963fcd0",
  null
  
)

export default component.exports